import type { BaseUserState } from '~/types/tShared';

import { EnhancedUserState } from '~/store/enhanceUser/index';
import { UserNotificationPreference } from '~/store/enhanceUser/types';

import axios from '../axios';
import { TRIALS_API_ROOT, V2_TIME_NOTIFICATIONS } from '../constants';

export const usersApi = {
  getCurrentUser: async (): Promise<BaseUserState & EnhancedUserState> => {
    return axios.get(`${TRIALS_API_ROOT}/v1/users/current-user`).then(({ data }) => data);
  },
  getNotificationPreferences: async (institutionId: string): Promise<UserNotificationPreference[]> => {
    return axios
      .get(`${V2_TIME_NOTIFICATIONS}/user/institutions/${institutionId}/notification-preferences`)
      .then(({ data }) => data);
  },
  updateNotificationPreference: async (body: UserNotificationPreference): Promise<UserNotificationPreference> => {
    return axios.patch(`${V2_TIME_NOTIFICATIONS}/notification-preferences`, body).then(({ data }) => data);
  },
};
